import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import Storage from 'src/utils/storage/storage';
import { ROUTES_MPTT_QUERY } from '../../../graph/SiteGraph';
import SettingsContainer from './SettingsContainer';

function SettingsView({ label, rootURL }) {
  const location = useLocation();
  const [subMenuMPTTData, setSubMenuMPTTData] = useState(null);

  // local state for source id
  const [sourceIdValue, setSourceIdValue] = useState(
    Storage.getSourceId().source
  );

  const [getLazyMPTTPages, lazyMPTTPages] = useLazyQuery(ROUTES_MPTT_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'cache-first' // Used for subsequent executions
  });

  useEffect(() => {
    getLazyMPTTPages({
      variables: {
        sidebar: true,
        reqNodeName: 'SRM',
        level: 2,
        sourceId: sourceIdValue.toString()
      },
      onCompleted: (pageData) => {
        console.log('this is mptt settings data🍇🍇🍇', pageData);
        const defaultPageList = pageData.defaultRoutesMptt;
        const appPageList = pageData.appRoutesMptt;
        const pageList = [...defaultPageList, ...appPageList];
        const dedupedData = _.uniqWith(pageList, _.isEqual).filter(
          (item) => item
        );
        dedupedData.map((menu) => {
          // let pageGroupList = layout['children']
          // pageGroupList.map((pageGroup) => {
          if (menu?.level >= 1 && menu.pages) {
            const menuItem = menu.pages;
            menuItem.map((page) => {
              if (page.sidebarUrl == location.pathname) {
                console.log(
                  'sidebar url matches location url, checking if submenu available 🍉🍉🍉'
                );
                setSubMenuMPTTData(page.subPages);
              }
            });
          }
          // })
        });
      }
    });
  }, [sourceIdValue]);

  return (
    <React.StrictMode>
      <Helmet>
        <title>Settings</title>
      </Helmet>
      <SettingsContainer
        subMenuData={subMenuMPTTData}
        rootURL={rootURL}
        label={label}
      />
    </React.StrictMode>
  );
}

export default SettingsView;
